import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  role?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'cream' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <section aria-label={title ?? 'Testimonials'} className={`w-full ${background === 'cream' ? 'bg-cream' : 'bg-white'}`} data-id="element-191" data-mp="3ayhzvk6j9hq9">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-192" data-mp="31zmu297ei9nh">
        {title && <h2 className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center mb-10" data-id="element-193" data-mp="2x09xgwqq9o7p">
            {title}
          </h2>}
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-194" data-mp="2s39reltvolgl">
          {testimonials.map(t => <li key={t.quote} className={`flex flex-col rounded-2xl border border-cream-dark p-6 shadow-card ${background === 'cream' ? 'bg-white' : 'bg-cream'}`} data-id="element-195" data-mp="v8nad69yidgi">
              <div className="flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-196" data-mp="m4rowevdji7h">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-terracotta text-terracotta" aria-hidden="true" data-id="element-197" data-mp="7926srtb7p81" data-mpi={i} />)}
              </div>
              <QuoteIcon className="w-6 h-6 text-sage-soft mt-4" aria-hidden="true" data-id="element-198" data-mp="zx7qdb8mn86a" />
              <blockquote className="mt-2 text-ink text-[15px] leading-relaxed flex-grow" data-id="element-199" data-mp="q6wcowz55km7">
                “{t.quote}”
              </blockquote>
              <footer className="mt-5 pt-4 border-t border-cream-dark flex items-center gap-3" data-id="element-200" data-mp="v4emepkzg3v9">
                <span className="w-9 h-9 rounded-full bg-sage-tint text-sage font-bold flex items-center justify-center text-sm" aria-hidden="true" data-id="element-201" data-mp="1iuihu9o0oxb6">
                  {t.author.charAt(0)}
                </span>
                <span className="text-sm" data-id="element-202" data-mp="1siebn5984nry">
                  <span className="block font-semibold text-ink" data-id="element-203" data-mp="1sjfmb8mbv895">{t.author}</span>
                  {t.role && <span className="block text-xs text-ink-muted" data-id="element-204" data-mp="1ojf9ttish74q">{t.role}</span>}
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}